<template>
    <div class="flex-fill"></div>
</template>
<script setup lang="ts">
defineModel<string>({ required: false });

defineExpose({ focus: () => {} });
</script>
